// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Modules
import { MixedCheckbox } from '@reach/checkbox';
import VisuallyHidden from '@reach/visually-hidden';
// Interface
import { AgeGroupFilterProps } from '@utmb/types/runner-ranking-table';
import { IconsEnum } from '@utmb/types/icons';
import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';
// Design System
import { DropDown, DropDownItem } from '@utmb/design-system/dropdown/Dropdown';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { Separator } from '@utmb/design-system/separator/Separator';
// Utils
import { rem } from '@utmb/utils/font';
// Styles
import styles from './filters.module.scss';

const AgeGroupFilter = (props: AgeGroupFilterProps): ReactElement => {
    const { ageGroups, fetchData, query, currentCategory, setCurrentAgeGroup, currentAgeGroup } = props;

    const { t } = useTranslation();

    const handleInputAgeGroupChange = (age: string): void => {
        if (currentAgeGroup === age) {
            setCurrentAgeGroup('');
            query.ageGroup = '';
        } else {
            setCurrentAgeGroup(age);
            query.ageGroup = age;
        }

        fetchData(query);
    };

    return (
        <div className={styles.toolbar}>
            <DropDown
                className={styles.drop}
                button={({ isExpanded }) => (
                    <>
                        <Font.FuturaHeavy mobile="14" desktop="16">
                            {t('performanceTable.ageGroup')}
                        </Font.FuturaHeavy>
                        <Icon
                            color={currentCategory === PiCategoryEnum.PI100M ? 'var(--utmb-color-white)' : 'var(--utmb-color-ws-primary)'}
                            variant={IconsEnum[isExpanded ? 'CHEVRON_UP' : 'CHEVRON_DOWN']}
                        />
                    </>
                )}
            >
                {ageGroups?.map((age: string, index: number) => {
                    const checked = age === currentAgeGroup;

                    const hasSeparator = index < ageGroups.length - 1;

                    return (
                        <div key={index} className={styles.item_wrapper}>
                            <DropDownItem onSelect={() => handleInputAgeGroupChange(age)} className={styles.item}>
                                <Font.OxaniumMedium mobile="12" desktop="14" as="span">
                                    {age}
                                </Font.OxaniumMedium>
                                <label>
                                    <MixedCheckbox value={age} checked={true} />
                                    {checked && <Icon variant={IconsEnum.CHECKBOX} color="rgba(65, 80, 92,.8)" />}
                                    <VisuallyHidden> {age}</VisuallyHidden>
                                </label>
                            </DropDownItem>
                            {hasSeparator && <Separator color="rgba(65, 80, 92,.2)" spacing="0 auto" depth={`calc(100% - ${rem('15px')})`} />}
                        </div>
                    );
                })}
            </DropDown>
        </div>
    );
};

export default AgeGroupFilter;
